// FREM source/common data is SDP consumer-API read-only. Derived/cache persistence target is repository files only.
// Flip repository readiness only in the same reviewed commit that adds a complete validated public/data/frem-daily/v1 snapshot.
export const DAILY_ANALYSIS_ENABLED = true;
export const DAILY_ANALYSIS_REPOSITORY_CACHE_READY = true;
export const DAILY_ANALYSIS_REPOSITORY_BASE_PATH = "/data/frem-daily/v1" as const;
